import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

const CredentialsInfoDialogItem = ({ title, description }: { title: string; description: string }) => {
  return (
    <React.Fragment>
      <Typography2 component="h3" variant="subtitleMedium">
        {title}
      </Typography2>
      <Typography2 variant="bodyPrimary" component="p">
        {description}
      </Typography2>
    </React.Fragment>
  );
};

export default CredentialsInfoDialogItem;
